import React from 'react';

const About = () => (
  <div>Hello From About Page</div>
);

export default About;
